package ru.playa.sce.dto


enum class AssetType {
    FILE,
    IMAGE,
    VIDEO
}